import { FETCH_GET } from "../../config";

export const GET_ALL_PAGES_PENDING = "GET_ALL_PAGES_PENDING";
export const GET_ALL_PAGES_FULFILLED = "GET_ALL_PAGES_FULFILLED";
export const GET_ALL_PAGES_REJECTED = "GET_ALL_PAGES_REJECTED";

export const getAllPagesData = () => {
  const query = `query={getAllPagesData{
    id,
    location,
    menu_title,
    content_title,
    slug,
    active,
    order,
    content,
  }}`;
  return async dispatch => {
    dispatch({ type: GET_ALL_PAGES_PENDING });
    try {
      const result = await FETCH_GET(query);
      if (result.data.errors) {
        dispatch({
          type: GET_ALL_PAGES_REJECTED,
          payload: result.data.errors
        });
      } else {
        dispatch({
          type: GET_ALL_PAGES_FULFILLED,
          payload: result.data.data.getAllPagesData
        });
      }
    } catch (e) {
      dispatch({ type: GET_ALL_PAGES_REJECTED });
    }
  };
};



// WEBPACK FOOTER //
// ./src/store/actions/page.js